import { defineStore } from 'pinia'

export type ThemeMode = 'light' | 'dark'
const KEY = 'clevver_theme'

function initialMode(): ThemeMode {
  const stored = localStorage.getItem(KEY)
  if (stored === 'light' || stored === 'dark') return stored
  return window.matchMedia?.('(prefers-color-scheme: dark)').matches ? 'dark' : 'light'
}

export const useThemeStore = defineStore('theme.store', {
  state: () => ({ mode: initialMode() as ThemeMode }),
  actions: {
    setMode(mode: ThemeMode) {
      this.mode = mode
      localStorage.setItem(KEY, mode)
      // Keep the document in sync so any non-.dashboard Bootstrap chrome matches.
      document.body.setAttribute('data-bs-theme', mode)
    },
    toggle() {
      this.setMode(this.mode === 'dark' ? 'light' : 'dark')
    },
  },
})
